import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import { AppName } from '../App';

let loginModalTimeout;

export const LoginModal = (props) => {
    const { ModalOpen, Retry, Timeout, ShowRetry } = props;
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        clearTimeout(loginModalTimeout);
        if (ModalOpen) {
            loginModalTimeout = setTimeout(() => {
                setIsOpen(ModalOpen);
            }, Timeout);
        }
        else {
            setIsOpen(ModalOpen);
        }
    }, [ModalOpen]);

    return (
        <Modal isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} backdrop={false} className="shadow-lg" style={{marginTop: 85}}>
            <ModalBody className="p-0">
                <div className="p-3">
                    <h4>Logging In</h4>
                    <div>Using your Greystar account to log you in to {AppName}.</div>
                </div>
                {ShowRetry && <div className="border-top p-3">
                    <div>There was an issue logging you in.</div>
                    <div className="text-end">
                        <Button color="light" className="border me-1" onClick={() => setIsOpen(!isOpen)}>Cancel</Button>
                        <Button color="secondary" onClick={Retry}>Retry</Button>
                    </div>
                </div>}
            </ModalBody>
        </Modal>
    );
};


// WEBPACK FOOTER //
// ./src/components/LoginModal.js